<template>
  <div class="controller-page">

    <template v-if="user.isController">
        <h1 class="heading">
            <b>[&nbsp;</b>
            <i>Pass control</i>
            <b>&nbsp;]</b>
        </h1>
    </template>

    <template v-else>
        <h1 class="heading">
            <b>[&nbsp;</b>
            <i>Wait for control</i>
            <b>&nbsp;]</b>
        </h1>
    </template>    

    <ul class="names-list" :class="{enabled:user.isController}">
      <li
        v-for="(u) in usersList"
        :key="u.key"
        :class="{active:u.isController}"
        @click="switchController({name:u.name,key:u.key})"
      >
        <b>> </b> 

        <template v-if="u.key == controllerKey"> <b>{{u.name}} <i v-if="u.key == user.key"> (you)</i></b> </template>
        <template v-else>{{u.name}} <i v-if="u.key == user.key"> (you)</i></template>
         
      </li>
    </ul>

    <button @click="closePage">CLOSE</button>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "controller-page",
  computed: {
    ...mapGetters(["usersList"]),
    ...mapState(["controllerKey", "user"])
  },
  filters: {
    leadingZero: function(value) {
      if (!value) {
        return "";
      } else if (value < 10) {
        return "0" + value;
      } else {
        return value;
      }
    }
  },
  methods: {
    switchController(payload) {
      if (this.user.isController) {
        var c = confirm("Pass control to " + payload.name);
        if (c) {
          this.$store.dispatch("switchControllerTo", payload.key);
        }
      }
    },
    closePage() {
      this.$store.commit('SET_CONTROLLER_PAGE', false);
    }
  }
};
</script>

<style lang="scss" scoped>
.controller-page {
  background-image: url("~@/assets/images/page-blank.png");
  width: 768px;
  height: 768px;
  padding: 120px;
  position: relative;

  .heading {
    margin-bottom: 1em;
  }

  .names-list {
    list-style: none;
    margin: 0;
    padding: 0;
    font-size: 30px;
    font-weight: 100;
    max-height: 530px;
    // overflow: scroll;

    &.enabled li:not(.active) {
      cursor: pointer;
    }

    li {
      margin-bottom: 5px;
      opacity: 0.5;

      &.active {
        opacity: 1;
      }
    }

    // .name-id {
    //   display: inline-block;
    //   width: 2.4em;

    //   i {
    //     display: inline-block;
    //     width: 45px;
    //     text-align: center;
    //   }
    // }
  }
  button {
    position: absolute;
    bottom: 118px;
    right: 118px;
    width: 60px;
    height: 30px;
    // padding: 10px;
    cursor: pointer;
    font-size: 13px;
    line-height: 32px;
    background-color: black;
    color: #f1ece6;
    border: none;
    outline: none;
    animation: flickerAnimation 3s infinite;
  }
}
</style>
